/* ============================================================================
   Ficha de producto HP (main-product y smiley-world-product)
   ----------------------------------------------------------------------------
   1. Guía de tallas (snippets/hp-size-guide.liquid): abre el modal con «Ver
      tallas» y lo cierra con la X, clic fuera o Escape.
   2. «Quedan pocos» (snippets/hp-low-stock.liquid): al cambiar de variante,
      se muestra solo si a la nueva le quedan de 1 a 4 unidades. La variante
      se lee del <select name="id"> de la ficha (lo actualiza Canopy).
   3. Barra flotante «Agregar al carrito» (snippets/hp-sticky-atc.liquid,
      patrón CAT): aparece cuando el bloque de compra quedó arriba fuera de la
      pantalla, se esconde cerca del footer y pulsa el botón real del form.
   Vanilla JS, sin dependencias.
   ============================================================================ */
(function () {
  'use strict';

  if (window.__hpPdp) return;
  window.__hpPdp = true;

  // --- 1. Guía de tallas ---------------------------------------------------------
  var lastTrigger = null;

  function guide() {
    return document.querySelector('[data-hp-size-guide]');
  }

  function openGuide(trigger) {
    var modal = guide();
    if (!modal) return;
    lastTrigger = trigger || null;
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = modal.querySelector('[data-hp-size-guide-close]');
    if (close) close.focus();
  }

  function closeGuide() {
    var modal = guide();
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-hp-size-guide-open]');
    if (opener) {
      e.preventDefault();
      openGuide(opener);
      return;
    }
    if (e.target.closest('[data-hp-size-guide-close]') || e.target.hasAttribute('data-hp-size-guide')) {
      closeGuide();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeGuide();
  });

  // --- 2. «Quedan pocos» -----------------------------------------------------------
  function updateLowStock(variantId) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hp-low-stock]'), function (el) {
      var source = el.parentElement && el.parentElement.querySelector('[data-hp-low-stock-data]');
      if (!source) return;
      var stock;
      try {
        stock = JSON.parse(source.textContent);
      } catch (e) {
        return;
      }
      if (!Object.prototype.hasOwnProperty.call(stock, String(variantId))) return; // otro producto
      var units = stock[String(variantId)];
      // data-hp-limit (no data-limit: Canopy reescribe todo [data-limit] de la ficha
      // con el stock de la variante para limitar la cantidad).
      var limit = parseInt(el.getAttribute('data-hp-limit'), 10) || 5;
      el.hidden = !(typeof units === 'number' && units > 0 && units < limit);
    });
  }

  // --- 3. Barra flotante «Agregar al carrito» (snippets/hp-sticky-atc.liquid) ------
  function stickyFor(form) {
    var id = form && form.getAttribute('data-product-id');
    return id ? document.querySelector('[data-hp-sticky-atc][data-product-id="' + id + '"]') : null;
  }

  function stickyData(root) {
    if (!root.__hpData) {
      try {
        root.__hpData = JSON.parse(root.querySelector('[data-hp-sticky-variants]').textContent);
      } catch (e) {
        root.__hpData = { labels: {}, variants: [] };
      }
    }
    return root.__hpData;
  }

  function updateSticky(form, variantId) {
    var root = stickyFor(form);
    if (!root) return;
    var data = stickyData(root);
    var variant = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === String(variantId)) variant = data.variants[i];
    }
    if (!variant) return;

    var title = root.querySelector('[data-hp-sticky-variant]');
    var price = root.querySelector('[data-hp-sticky-price]');
    var image = root.querySelector('[data-hp-sticky-image]');
    var button = root.querySelector('[data-hp-sticky-add]');
    var label = root.querySelector('[data-hp-sticky-label]');
    if (title) title.textContent = variant.title;
    if (price) price.textContent = variant.price;
    if (image && variant.image) image.src = variant.image;
    if (button) button.disabled = !variant.available;
    if (label) label.textContent = variant.available ? data.labels.add : data.labels.unavailable;
    root.setAttribute('data-available', variant.available ? 'true' : 'false');
    if (root.__hpRender) root.__hpRender();
  }

  function initSticky(root) {
    if (root.__hpInit) return;
    var form = document.querySelector('form.hp-pdp[data-product-id="' + root.getAttribute('data-product-id') + '"]');
    var buyBox = form && form.querySelector('.hp-pdp-buy');
    var bar = root.querySelector('.hp-sticky-atc__bar');
    if (!form || !buyBox || !bar) return;
    root.__hpInit = true;

    var footer = document.querySelector('footer') || document.querySelector('[data-section-type="footer"]');

    // Se mide la posición en cada scroll (una vez por cuadro) en vez de usar
    // IntersectionObserver: el observer solo avisa cuando cambia la visibilidad,
    // y si se baja de golpe (deslizar rápido en el celular, un enlace a
    // «Reseñas») el bloque de compra pasa de «abajo, no visible» a «arriba, no
    // visible» sin aviso y la barra no aparecía (visto en Safari/iPhone).
    function render() {
      var pastBuyBox = buyBox.getBoundingClientRect().bottom < 0;
      var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var show = pastBuyBox && !nearFooter && root.getAttribute('data-available') === 'true';
      bar.setAttribute('data-stuck', show ? 'true' : 'false');
      document.body.classList.toggle('hp-sticky-atc-on', show);
    }
    root.__hpRender = render;

    // Directo en cada scroll: son dos lecturas de posición, sin costo apreciable,
    // y no depende del orden entre el evento de scroll y el siguiente cuadro.
    window.addEventListener('scroll', render, { passive: true });
    window.addEventListener('resize', render);
    // Reseñas y recomendaciones cargan después y empujan el footer hacia abajo
    // sin que haya scroll: se recalcula también cuando cambia el alto de la página.
    if ('ResizeObserver' in window) new ResizeObserver(render).observe(document.body);
    window.addEventListener('load', render);
    render();

    // Pulsa el botón real: misma cantidad, validación y minicart de Canopy.
    root.querySelector('[data-hp-sticky-add]').addEventListener('click', function () {
      var add = form.querySelector('button[name="add"]');
      if (add && !add.disabled) add.click();
    });
  }

  function initAllSticky() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-hp-sticky-atc]'), initSticky);
  }

  // --- Cambio de variante -------------------------------------------------------------
  // No se usa el evento `cc-variant-updated` de Canopy: en la página hay más de
  // una copia de jQuery (las apps cargan la suya) y el listener podía quedar en
  // otra instancia. En su lugar, tras cada clic/cambio en la ficha se lee la
  // variante elegida del <select name="id"> que Canopy mantiene al día.
  function syncFromForm(form) {
    var select = form && form.querySelector('select[name="id"]');
    if (!select || !select.value) return;
    updateLowStock(select.value);
    updateSticky(form, select.value);
  }

  function onInteraction(e) {
    var form = e.target.closest && e.target.closest('form.hp-pdp');
    if (!form) return;
    setTimeout(function () { syncFromForm(form); }, 60);
  }

  document.addEventListener('click', onInteraction);
  document.addEventListener('change', onInteraction);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllSticky);
  else initAllSticky();
  document.addEventListener('shopify:section:load', initAllSticky);
})();
